import type { RunScreenerQueryStateAtomValue } from "components/screener/v2/atoms";
import { runScreenerQueryStateAtom } from "components/screener/v2/atoms";
import TwoPassRender from "components/shared/TwoPassRender";
import { Badge } from "components/ui/Badge";
import classNames from "components/ui/classNames";
import { useAtomValue } from "jotai";
import { selectAtom } from "jotai/utils";
import { useIsOnline } from "lib/hooks/useIsOnline";
import { GaugeIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface LatencyProps {
  className?: string;
}
const getLatency = (state: RunScreenerQueryStateAtomValue) => state?.latency;
export const Latency = ({ className }: LatencyProps) => {
  const intl = useIntl();
  // TODO(Andrey): Overlay based on `isOnline`
  const isOnline = useIsOnline();
  const latency = useAtomValue(selectAtom(runScreenerQueryStateAtom, getLatency));
  if (!latency) {
    return null;
  }
  return (
    <div className={classNames("flex items-center gap-2", className)}>
      <Badge
        // eslint-disable-next-line no-nested-ternary
        variant={latency > 1000 ? "rose" : latency > 700 ? "orange" : "viridian"}
        className="inline-flex gap-x-1 rounded-md"
        title={intl.formatMessage({ defaultMessage: "Latência", id: "DUsxX3" })}
      >
        <GaugeIcon className="inline-flex size-4" />
        {formatSecondsOrMillis(latency)}
      </Badge>
      <TwoPassRender>
        {() => {
          return (
            <span className="relative inline-flex h-2 w-2 md:h-2 md:w-2">
              <span
                className={classNames("absolute inline-flex h-full w-full rounded-full opacity-80", {
                  "animate-ping-slow animate-ping bg-green-600/50 dark:bg-lime-400": isOnline,
                  "bg-red-600/50": !isOnline,
                })}
              />
              <span
                className={classNames("relative inline-flex h-2 w-2 rounded-full md:h-2 md:w-2", {
                  "bg-green-600 dark:bg-lime-500": isOnline,
                  "bg-red-600": !isOnline,
                })}
              />
            </span>
          );
        }}
      </TwoPassRender>
    </div>
  );
};

function formatSecondsOrMillis(value: number) {
  if (value < 1000) {
    return `${value}ms`;
  }
  return `${(value / 1000).toFixed(2)}s`;
}
